import { combineReducers } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";
import language from "../components/LanguageSelect/LanguageState";
import forms from "../store/reducers/form";
import formBuilder from "../store/reducers/formBuilder";
import AedoList from "./../old/components/AedoList/AedoListReducer";
import app from "./../old/pages/AppReducer";
import auth from "./../old/pages/auth/authReducer";
import bim from "./../old/pages/bim-models/bimReducer";
import bimView from "./../old/pages/bim/bimReducer";
import AedoForgeMeasurementExtension from "./../old/pages/bim/forge/viewer/extensions/measurementReducer";
import AedoForgeNoteExtension from "./../old/pages/bim/forge/viewer/extensions/noteReducer";
import calculation from "./../old/pages/calculation/calculationReducer";
import companies from "./../old/pages/company/companyReducer";
import finance from "./../old/pages/invoices/invoicesReducer";
import issues from "./../old/pages/issues/issueReducer";
import offers from "./../old/pages/offers/offerReducer";
import projectDetails from "./../old/pages/project-details/projectDetailsReducer";
import purchasingInvoices from "./../old/pages/purchasing-invoices/purchasingInvoicesReducer";
import search from "./../old/pages/search/searchReducer";
import users from "./../old/pages/user/userReducer";
import worklogReport from "./../old/pages/worklog-reports/reducer";
import currentWeekLogs from "./../old/pages/worktime/worktimeReducer";
import project from "./../pages/project/projectReducer";

const initialReducers = {
  auth,
  project,
  projectDetails,
  calculations: calculation,
  users,
  companies,
  search,
  form: formReducer,
  finance,
  issues,
  currentWeekLogs,
  worklogReport,
  app,
  purchasingInvoices,
  offers,
  bim,
  bimView,
  AedoForgeNoteExtension,
  AedoForgeMeasurementExtension,
  list: AedoList,
  forms,
  formBuilder,
  language,
};
export { initialReducers };

const rootReducer = combineReducers(initialReducers);

export default rootReducer;
